import React from 'react';

interface ProfileNavigationProps {
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onPrevious: () => void;
  canProceed: boolean;
  buttonText?: string;
  isSaving?: boolean;
}

const ProfileNavigation: React.FC<ProfileNavigationProps> = ({
  currentStep,
  totalSteps,
  onNext,
  onPrevious,
  canProceed,
  buttonText,
  isSaving = false,
}) => {
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps - 1;

  return (
    <div className="flex justify-center items-center gap-6 mt-6 sm:mt-8 max-w-4xl mx-auto">
      {/* Previous Button */}
      {!isFirstStep && (
        <button
          type="button"
          onClick={onPrevious}
          className="flex items-center gap-1.5 text-sm text-gray-400 hover:text-white transition-colors"
          aria-label="Previous step"
        >
          <svg
            className="w-5 h-5 text-gray-400"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
          Back
        </button>
      )}

      {/* Next/Save Button */}
      <div>
        {!isLastStep ? (
          <button
            type="button"
            onClick={onNext}
            disabled={isSaving}
            className="profile-save-rainbow font-medium text-sm rounded-lg relative text-white transition-transform duration-200 hover:scale-105 active:scale-110 disabled:hover:scale-100 disabled:opacity-80"
          >
            <span className="bg-dark-950 px-3 py-1.5 sm:px-3.5 sm:py-2 rounded-lg flex items-center justify-center gap-2 min-w-[5.5rem]">
              {isSaving ? (
                <>
                  <span
                    className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"
                    aria-hidden
                  />
                  Saving…
                </>
              ) : (
                buttonText || 'SAVE'
              )}
            </span>
          </button>
        ) : (
          <button
            type="button"
            onClick={onNext}
            disabled={isSaving}
            className="inline-flex items-center justify-center px-4 py-2 sm:px-5 sm:py-2.5 font-medium text-sm rounded-lg bg-emerald-700 hover:bg-emerald-800 text-white transition-transform duration-200 hover:scale-105 active:scale-110 disabled:hover:scale-100"
          >
            {isSaving ? (
              <>
                <span
                  className="mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"
                  aria-hidden
                />
                Saving…
              </>
            ) : (
              'Complete Profile'
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default ProfileNavigation;
